<!-- Displaying all the tickets raised by a customer-->
<!-- if role is not customer, user cannot raise ticket-->
<ng-container *ngIf="role && role !== 'CUSTOMER'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>

<ng-container *ngIf="role && role === 'CUSTOMER'">
  <div class="wrapper ">
    <br>
    <div>
      <div class="content">
        <ng-container *ngIf="tickets">
          <div class="alert alert-danger" role="alert" *ngIf="tickets.length === 0">
            No Tickets
          </div>
          <div class="alert alert-primary" role="alert" *ngIf="tickets.length !== 0">
            Browse Tickets
          </div>
          <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th scope="col">Ticket ID</th>
                  <!--<th scope="col">Moderator</th>
                  <th scope="col">Tech Expert</th>-->
                  <!-- <th scope="col">Message</th> -->
                  <th scope="col">Created On</th>
                  <th scope="col">Updated On</th>
                  <!-- <th scope="col">EXPERT REPLY</th> -->
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ticket of tickets">
                  <td>{{ ticket._id }}</td>
                  <!--<td>{{ ticket.moderator.fullName }}</td>
                  <td>
                    <div *ngIf="ticket.techExpert" style="font-weight: bolder;">
                      {{ ticket.techExpert.fullName }}
                    </div>
                    <div *ngIf="!ticket.techExpert" style="font-style: italic;">
                      Your Ticket is yet to be assigned to one of our experts
                    </div>
                  </td>-->
                  <!-- <td>
                    <div *ngIf="ticket.message[0]">{{ ticket.message[0]['message'] }}</div>
                    <div *ngIf="!ticket.message[0]">NO MESSAGE TO DISPLAY</div>
                  </td> -->
                  <td>{{ ticket.createdAt }}</td>
                  <td>{{ ticket.updatedAt }}</td>
                  <!-- <td>
                    <button class="submit" ><mat-icon>question-answer</mat-icon></button>
                  </td> -->
                  <!-- <td>
                    <div *ngFor="let message of ticket.message">
                      <div *ngIf="message">
                        <li *ngIf="message['role']==='TECHEXPERT'">
                          {{message['message']}}
                        </li>
                      </div>
                      <div *ngIf="!message">NO MESSAGE TO DISPLAY</div>
                    </div>
                  </td> -->
                  <td>
                    <button class="btn  btn-outline-primary" (click)="open(mymodal, ticket.message, ticket._id,ticket.isOpen)">See Chat</button>
                    <button *ngIf="ticket.isOpen" class="btn btn-outline-primary" (click)="closeTicket(ticket._id, feedbackmodal)">Close</button>
                    <button type="button" class="btn btn-success" (click)="sendCurveDataToAnalyser(ticket.curveData, ticket.heatNumber)">View Curve</button>
                    <!-- <button class="btn btn-warn" (click)="openAllAttachments(viewattachmentmodal,ticket._id)">View attachment</button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </ng-container>

        <ng-template #mymodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">See your chat with expert</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
            <div class="modal-body">
              <div class="blinking"><p>After sending message<br>Refresh the page for display of reply message !!!</p></div>

              <div id="container">
                <main>
                  <ul id="chat">
                    <div *ngFor='let message of messages'>
                      <div *ngIf="message.verified === true">
                        <div *ngIf="message.role === 'TECHEXPERT'">
                          <li class="you">
                            <div class="entete">
                              <span class="status green"></span>
                              <h2>Expert</h2>
                              <h3> | {{transformDate(message.createdAt)}}</h3>
                            </div>
                            <div class="triangle"></div>
                            <div class="message">
                              {{message.message}}
                            </div>
                          </li>
                        </div>
                        <div *ngIf="message.role === 'CUSTOMER'">
                          <li class="me">
                            <div class="entete">
                              <h3>{{transformDate(message.createdAt)}} | </h3>
                              <h2>You</h2>
                              <span class="status blue"></span>
                            </div>
                            <div class="triangle"></div>
                            <div class="message">
                              {{message.message}}
                            </div>
                          </li>
                        </div>
                      </div>

                    </div>
                  </ul>
                  <footer>
                    <textarea [(ngModel)]="customerMessage" placeholder="Type your message" required></textarea>
                    <div class="footer-buttons">
                    <a (click)="replyToTicket()"><button class="send" [disabled]="isOpen==false">Send</button></a>
                    <!-- <button class="attachment" [disabled]="isOpen==false" (click)="openattachment(attachmentmodal)">add attachment</button>
                    <button class="reset-attachment" [disabled]="isOpen==false" (click)="resetAttachment()">reset attachment</button> -->
                    </div>
                  </footer>
                </main>
              </div>
            </div>
            <div class="modal-footer">
              Your communication is not end-to-end encrypted
            </div>
        </ng-template>

        <ng-template #feedbackmodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">Feedback</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
            <div class="modal-body">
              <div id="container">
                <main style="text-align: center; padding: 2em;">
                  <br>
                  <p>Please rate.</p>
                  <ngb-rating [max]="5" [(rate)]="rate" [readonly]="false"></ngb-rating>
                  <br><br>
                  <p>Other details.</p>
                  <textarea rows="4" cols="50" [(ngModel)]="feedbackMessage" placeholder="Type here ..." required></textarea>
                  <br>
                </main>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-lg btn-success" (click)="sendFeedback()">Send</button>
            </div>
        </ng-template>



        <!--attachments-->
        <ng-template #attachmentmodal let-modal>
          <div class="modal-header">
            <h4 class="modal-title" id="modal-attachment-title">Add an attachment</h4>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <!-- (submit)="saveTicket()" [formGroup]="ticketForm" -->
          <form>
            <div class="modal-body" style="margin: 0 auto;">

              <div class="columns">
                <div class="column is-one-third">
                  <div class="field">
                    <div class="file has-name is-primary is-fullwidth">
                    <!--  <label class="file-label">
                        <input
                          class="file-input"
                          type="file"
                          name="file"
                          #fileInput
                          (change)="onChange(fileInput.files[0])"/>
                        </label>-->
                    </div>
                  </div>

                </div>
                <div class="column">
                  <figure *ngIf="imageUrl!=''">
                    <img height="300" width="300" [src]="imageUrl" />
                  </figure>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-outline-dark" (click)="modal.dismiss('added attachments')">Add attachment</button>
            </div>
            </form>
            </ng-template>




            <ng-template #viewattachmentmodal let-modal>
              <div class="modal-header">
               <!-- <h4 class="modal-title" id="modal-view-attachment-title">View attachments</h4> -->
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <!-- (submit)="saveTicket()" [formGroup]="ticketForm" -->
              <form>
                <div class="modal-body" style="margin: 0 auto;" *ngIf="attachments.length==0">
                 No attachments to display

                </div>
                <div class="modal-body" style="margin: 0 auto;" *ngIf="attachments.length!=0">
                   <ul *ngFor="let attachment of attachments">

                    <div *ngIf="attachment.role && attachment.role=='CUSTOMER'">
                      <p>Customer attachment : </p>
                      <li id="attachment.file"><a href="{{environment.apiBaseUrl+'/get-attachment/' + attachment.file }}" target="_blank">
                                <div *ngIf="!attachment.name">
                                {{attachment.file}}
                                </div>
                                <div *ngIf="attachment.name">
                                  {{attachment.name}}
                                </div>
                        </a></li>
                      </div>


                      <div *ngIf="attachment.role && attachment.role=='TECHEXPERT'">
                        <p>Expert attachment :</p>
                        <li id="attachment.file"><a href="{{environment.apiBaseUrl+'/get-attachment/' + attachment.file }}" target="_blank">
                          <div *ngIf="!attachment.name">
                          {{attachment.file}}
                          </div>
                          <div *ngIf="attachment.name">
                            {{attachment.name}}
                          </div>
                          </a></li>
                        </div>


                        <div *ngIf="!attachment.role">
                          <li id="attachment.file"><a href="{{environment.apiBaseUrl+'/get-attachment/' + attachment.file }}" target="_blank">
                            <div *ngIf="!attachment.name">
                            {{attachment.file}}
                            </div>
                            <div *ngIf="attachment.name">
                              {{attachment.name}}
                            </div>
                            </a></li>
                        </div>


                   </ul>
                </div>

                </form>
                </ng-template>

      </div>
    </div>
  </div>

</ng-container>
<!-- end of ticket display-->
